<template>
  <modal
    class="rate-supplier-modal"
    name="rate-supplier-modal"
    @before-open="beforeOpen"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="35%"
    height="auto"
  >
    <div id="modal-header" style="background-color:#006BE6">
      <div class="w-75 d-flex text-white">
        <p style="font-weight: 400;">Գնահատել մատակարարին</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('rate-supplier-modal')" aria-label="Close">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ffffff"/>
        </svg>
      </button>
    </div>
    <div id="modal-body" class="p-3">
      <h6 class="font-weight-bold">Հանրային ռեյտինգ</h6>
      <p class="text-muted small">Այս գնահատականը տեսանելի կլինի բոլոր օգտատերերին</p>

      <div class="form-group">
        <label>Ժամկետում մատակարարում</label>
        <div class="star-row">
          <i
            v-for="n in 5" :key="`public-time-${n}`"
            class="fa-star size mr-1"
            :class="n <= publicOnTime ? 'fas text-primary' : 'far text-secondary'"
            style="cursor: pointer;"
            @click="publicOnTime = n"
          ></i>
        </div>
      </div>

      <div class="form-group">
        <label>Պայմանագրին համապատասխան մատակարարում</label>
        <div class="star-row">
          <i
            v-for="n in 5" :key="`public-compliance-${n}`"
            class="fa-star size mr-1"
            :class="n <= publicCompliance ? 'fas text-primary' : 'far text-secondary'"
            style="cursor: pointer;"
            @click="publicCompliance = n"
          ></i>
        </div>
      </div>

      <template v-if="hasInternalRating">
        <hr>
        <h6 class="font-weight-bold">Ներքին ռեյտինգ</h6>
        <p class="text-muted small">Այս գնահատականը տեսանելի է միայն ձեզ</p>

        <div class="form-group">
          <label>Ժամկետում մատակարարում</label>
          <div class="star-row">
            <i
              v-for="n in 5" :key="`internal-time-${n}`"
              class="fa-star size mr-1"
              :class="n <= internalOnTime ? 'fas text-primary' : 'far text-secondary'"
              style="cursor: pointer;"
              @click="internalOnTime = n"
            ></i>
          </div>
        </div>

        <div class="form-group">
          <label>Պայմանագրին համապատասխան մատակարարում</label>
          <div class="star-row">
            <i
              v-for="n in 5" :key="`internal-compliance-${n}`"
              class="fa-star size mr-1"
              :class="n <= internalCompliance ? 'fas text-primary' : 'far text-secondary'"
              style="cursor: pointer;"
              @click="internalCompliance = n"
            ></i>
          </div>
        </div>
      </template>
    </div>
    <div id="modal-footer">
      <button @click="$modal.hide('rate-supplier-modal')" type="button" class="btn btn-light mr-2">
        <span>Բաց թողնել</span>
      </button>
      <button :disabled="!publicOnTime || !publicCompliance || isLoading" @click="submit" type="button" class="btn btn-primary">
        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span>Հաստատել</span>
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'RateSupplierModal',
  data () {
    return {
      orderId: null,
      hasInternalRating: false,
      publicOnTime: 0,
      publicCompliance: 0,
      internalOnTime: 0,
      internalCompliance: 0,
      isLoading: false,
    }
  },
  methods: {
    beforeOpen({params}) {
      this.orderId = params.orderId
      this.hasInternalRating = Boolean(params.hasInternalRating)
      this.publicOnTime = 0
      this.publicCompliance = 0
      this.internalOnTime = 0
      this.internalCompliance = 0
    },
    submit() {
      this.isLoading = true
      const payload = {
        on_time_score: this.publicOnTime,
        compliance_score: this.publicCompliance,
      }
      if (this.hasInternalRating && this.internalOnTime && this.internalCompliance) {
        payload.internal_on_time_score = this.internalOnTime
        payload.internal_compliance_score = this.internalCompliance
      }
      this.$client.post(`contract-orders/${this.orderId}/rate`, payload).then(() => {
        this.isLoading = false
        this.$notify({
          group: 'foo',
          type: 'success',
          text: 'Գնահատականը հաջողությամբ ավելացվել է'
        })
        this.$modal.hide('rate-supplier-modal')
      }).catch(() => {
        this.isLoading = false
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ինչ որ բան այն չէ',
          text: 'Կրկին փորձեք!'
        })
      })
    },
  }
}
</script>
<style scoped>
.star-row .fa-star {
  font-size: 20px;
}
</style>
